import IN_YOUR_BAG from './InYourBag.constants';
//
export const getInYourBagItemsAction = (payload) => ({
  type: IN_YOUR_BAG.GET_IN_YOUR_BAG_ITEMS,
  payload,
});

export const setInYourBagItems = (payload) => ({
  type: IN_YOUR_BAG.SET_IN_YOUR_BAG_ITEMS,
  payload,
});
